import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '@/Application/Hooks/Redux';
import { useGetOrderNumber } from '@/modules/perseo-billing/hooks/use-order-number';
import { getWebpayTokenFromActiveCartPayments } from '@/modules/perseo-billing/hooks/utils';

export const UseWebpayTokenHandler = () => {
  const { data: cart } = useAppSelector((state) => state.cart);

  const orderNumber = useGetOrderNumber();
  const navigate = useNavigate();

  useEffect(() => {
    if (!orderNumber) return;
    if (!cart || cart?.payments?.length === 0) return;

    const currentUrl = new URL(window?.location?.href);
    const searchParams = new URLSearchParams(currentUrl?.search);

    const token = getWebpayTokenFromActiveCartPayments(cart, orderNumber);
    if (token) {
      searchParams.set('TBK_TOKEN', token);

      const newUrl = `${currentUrl.pathname}?${searchParams.toString()}`;
      navigate(newUrl, {
        replace: true
      });
    }
  }, [cart, navigate, orderNumber]);
};
